import { formatProfitUsd } from '@/lib/format-profit';
import { DollarSignIcon } from 'lucide-react';

interface ProfitHeroCardProps {
	profitAmount: number;
	profitCount: number;
}

export default function ProfitHeroCard({ profitAmount, profitCount }: ProfitHeroCardProps) {
	return (
		<div className='rounded-xl border border-chart-5/20 bg-gradient-to-br from-chart-5/20 via-chart-5/10 to-transparent p-5 flex flex-col gap-1'>
			<div className='flex items-center gap-2 text-xs text-muted-foreground'>
				<DollarSignIcon size={14} className='text-chart-5' />
				Всего заработано
			</div>
			<span className='text-3xl font-bold tabular-nums text-chart-5'>${formatProfitUsd(profitAmount)}</span>
			<span className='text-sm text-muted-foreground'>
				{profitCount} {profitCount === 1 ? 'профит' : profitCount < 5 ? 'профита' : 'профитов'} · с момента регистрации
			</span>
		</div>
	);
}
